<template>
  <v-app :class="appThemeClass">
    <UniversalLayout />
    <ErrorPopup />
    <v-snackbar v-model="showSnackbar" :timeout="5000" :color="snackbarColor">{{ snackbarMessage }}</v-snackbar>
  </v-app>
</template>

<script>
import UniversalLayout from "./components/layout/Common/UniversalLayout.vue";
import ErrorPopup from "./components/layout/Popups/ErrorPopup.vue";
import { mapActions } from "vuex";
import { resolveTenantIdFromBrowser } from "./utils/tenant";

export default {
  name: 'App',
  components: {
    UniversalLayout,
    ErrorPopup,
  },
  data() {
    return {
      showSnackbar: false,
      snackbarMessage: '',
      snackbarColor: 'success',
      lastUserDataTenantId: null,
    };
  },
  computed: {
    appThemeClass() {
      return this.$store.getters["darkMode/isDarkMode"] ? 'dark-mode' : 'light-mode';
    }
  },
  methods: {
    ...mapActions("tenantId", ["getUserData"]),
    ensureUserBootstrap() {
      const hasToken = !!localStorage.getItem("authToken");
      if (!hasToken) {
        this.lastUserDataTenantId = null;
        return;
      }
      const tenantId = resolveTenantIdFromBrowser();
      if (!tenantId) {
        return;
      }
      if (this.lastUserDataTenantId === tenantId) {
        return;
      }
      this.lastUserDataTenantId = tenantId;
      this.getUserData();
    },
    showOnlineSnackbar() {
      this.snackbarMessage = 'Back Online';
      this.showSnackbar = true;
      this.snackbarColor = 'success';
    },
    showOfflineSnackbar() {
      this.snackbarMessage = 'You are currently offline. Please check your internet connection.';
      this.showSnackbar = true;
      this.snackbarColor = 'error';
    },
  },
  watch: {
    $route() {
      this.ensureUserBootstrap();
    },
  },
   mounted() {
    this.ensureUserBootstrap();
    if (!navigator.onLine) {
      this.showOfflineSnackbar();
    }
    window.addEventListener('offline', this.showOfflineSnackbar);
    window.addEventListener('online', this.showOnlineSnackbar);
  },
}
</script>
